/**
 * Build web-search queries for in-board suggest-pins from current recommendations.
 * Prefers search queries; falls back to gap strings.
 */
export function buildSuggestPinQueries({ searchQueries = [], searchQuery = '', gaps = [] } = {}) {
  const fromSearches = (searchQueries || [])
    .map(item => (typeof item === 'string' ? item : item?.query))
    .map(query => String(query || '').trim())
    .filter(Boolean);
  if (fromSearches.length) return fromSearches.slice(0, 5);

  const single = String(searchQuery || '').trim();
  if (single) return [single];

  return (gaps || [])
    .map(gap => String(gap || '').trim())
    .filter(Boolean)
    .slice(0, 5);
}
